"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneState = exports.isTransitioning = exports.getStateName = exports.MergedError = exports.StateFlow = exports.SignalType = exports.createSignal = exports.ResultKind = exports.Result = void 0;
const tslib_1 = require("tslib");
const dispose_1 = tslib_1.__importDefault(require("core-js-pure/actual/symbol/dispose"));
if (typeof Symbol.dispose === "undefined") {
    Object.defineProperty(Symbol, "dispose", {
        value: dispose_1.default,
    });
}
var result_1 = require("./result");
Object.defineProperty(exports, "Result", { enumerable: true, get: function () { return result_1.Result; } });
Object.defineProperty(exports, "ResultKind", { enumerable: true, get: function () { return result_1.ResultKind; } });
var signals_1 = require("./signals");
Object.defineProperty(exports, "createSignal", { enumerable: true, get: function () { return signals_1.createSignal; } });
Object.defineProperty(exports, "SignalType", { enumerable: true, get: function () { return signals_1.SignalType; } });
var state_flow_1 = require("./state-flow");
Object.defineProperty(exports, "StateFlow", { enumerable: true, get: function () { return state_flow_1.StateFlow; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "MergedError", { enumerable: true, get: function () { return utils_1.MergedError; } });
Object.defineProperty(exports, "getStateName", { enumerable: true, get: function () { return utils_1.getStateName; } });
Object.defineProperty(exports, "isTransitioning", { enumerable: true, get: function () { return utils_1.isTransitioning; } });
Object.defineProperty(exports, "cloneState", { enumerable: true, get: function () { return utils_1.cloneState; } });
//# sourceMappingURL=index.js.map